module.exports = __webpack_public_path__ + "static/media/ic_arrowLeftGreen.b2eae474.svg";